/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react'
import './button.css'

function Button(props: any): JSX.Element {
    const { label, icon, style, isGradient, color, onClick, size, type, isBackButton, btntype, isDisabled } = props

    let btnClass;
    
    if(isGradient && color === 'primary') {
        btnClass = `btn btn-sm bg-gradient-to-b border-0 from-[#ED4B52] to-[#D6242C] h-[35px] text-14 normal-case focus-visible:outline-none rounded-50 font-semibold text-white disabled:cursor-not-allowed disabled:btn-primary disabled:opacity-50 disabled:text-white hover:from-[#D6242C] hover:to-[#ED4B52] focus:shadow-md`
    } if(isGradient && color === 'blue') {
        btnClass = `btn btn-sm bg-gradient-to-b border-0 from-[#00A6FF] to-[#0090DD] h-[35px] text-14 normal-case focus-visible:outline-none rounded-50 font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white hover:from-[#0090DD] hover:to-[#00A6FF] focus:shadow-md`
    }
    if(isGradient && color === 'primary' && size === 'big') {
        btnClass = `${btnClass} btn btn-sm bg-gradient-to-b border-0 from-[#ED4B52] to-[#D6242C] h-[45px] w-[130px] text-14 normal-case focus-visible:outline-none rounded-50 font-semibold text-white disabled:btn-primary disabled:opacity-50 disabled:text-white hover:from-[#D6242C] hover:to-[#ED4B52] focus:shadow-md`
    }
    if(isGradient && color === 'primary' && size === 'small') {
        btnClass = `${btnClass} btn btn-sm bg-gradient-to-b border-0 from-[#ED4B52] to-[#D6242C] h-[35px] w-[100px] text-14 normal-case focus-visible:outline-none rounded-50 font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white hover:from-[#D6242C] hover:to-[#ED4B52] focus:shadow-md`
    }
    if(isGradient && color === 'primary' && size === 'medium') {
        btnClass = `${btnClass} btn btn-sm bg-gradient-to-b border-0 from-[#ED4B52] to-[#D6242C] h-[40px] w-[100px] text-14 normal-case focus-visible:outline-none rounded-50 font-semibold text-white disabled:btn-primary disabled:opacity-50 disabled:text-white hover:from-[#D6242C] hover:to-[#ED4B52] focus:shadow-md`
    }
    if(type === 'default') {
        btnClass = `${btnClass} btn btn-sm h-[39px] bg-[#FAFAFA] hover:bg-[#e9e9e9] hover:border-[#CBD1DC] border-[#CBD1DC] text-14 normal-case focus-visible:outline-none rounded-50 font-semibold text-muted disabled:bg-[#FAFAFA] disabled:border-[#CBD1DC] disabled:opacity-100 disabled:text-muted focus:shadow-none`
    }
    if(type === 'default' && size === 'medium') {
        btnClass = `btn btn-sm bg-inputbg h-[45px] border-1 border-inputborder hover:bg-[#e9e9e9] hover:border-inputborder w-[130px] text-14 normal-case focus-visible:outline-none rounded-50 font-semibold text-muted disabled:btn-primary disabled:opacity-100 disabled:text-white focus:shadow-none`
    }
    if(type === 'default' && size === 'small') {
        btnClass = `btn btn-sm bg-inputbg h-[35px] w-[100px] border-1 border-inputborder hover:bg-white hover:border-inputborder text-14 normal-case focus-visible:outline-none rounded-50 font-semibold text-muted disabled:btn-primary disabled:opacity-100 disabled:text-white focus:shadow-none`
    }
    if(isBackButton && color === 'secondary') {
        btnClass = `btn btn-sm border-0 rounder-none bg-white normal-case hover:bg-white text-muted2 focus:shadow-md`
    }

    if(isDisabled && color === "gray") {
        btnClass = `btn btn-sm border-0 rounder-none disabled:bg-[#F2F2F2] normal-case hover:bg-[#F2F2F2] rounded-full disabled:text-[#BBB] focus:shadow-md`
    }

    if(isGradient && color === 'green') {
        btnClass = `btn btn-sm bg-gradient-to-b border-0 from-[#2BD300] to-[#21A500] h-[35px] text-14 normal-case focus-visible:outline-none rounded-50 font-semibold text-white disabled:cursor-not-allowed disabled:btn-primary disabled:opacity-100 disabled:text-white hover:from-[#21A500] hover:to-[#2BD300] focus:shadow-md`
    }

    return (
        <>
            <button style={style} type={btntype} className={btnClass} onClick={onClick} disabled={isDisabled ? true : false}>
                {
                    icon && <span className='icon-wrapper'>{icon}</span>
                }
                {label}
            </button>
        </>
    )
}

export default Button